export default __webpack_public_path__ + "static/media/btn_backtotop.e76bb968.png";